import React from 'react';
import styled from 'styled-components';
import {AccentColorOptions, useBreakpointDown} from 'epic-ue-theme';
import {Button, Typography} from '../../../elements';
import {Card, Grid} from '@material-ui/core';
import { VerticalSpacer } from '../../spacer';

const Styled = styled(Card)`
    && {
        border-radius: 0;
        box-shadow: none;
        border: 0px;
        position: relative;
    }
    padding: 40px;

    .github-link-col {
        text-align: right;
        align-self: center;
    }
`;

export interface GithubCardProps {
    accentColor?: AccentColorOptions;
    description?: string;
    buttonText?: string;
    githubLink?: string;
}

export const GithubCard = ({
    accentColor = 'sky',
    description = '',
    buttonText = 'Get GITHUB access',
    githubLink = '#'
}: GithubCardProps): JSX.Element => {

    const isSm = useBreakpointDown('sm');

    return (
        <>
            <Styled>
                <Grid container direction="row" justifyContent="flex-start" alignItems="stretch">
                    <Grid item md={8}>
                        {description && (
                            <>
                                <Typography variant="h3" accentColor={accentColor}>
                                    {description}
                                </Typography>
                            </>
                        )}
                    </Grid>
                    <Grid className="github-link-col" item md={4}>
                        {githubLink && (
                            <>
                                {isSm && <VerticalSpacer variant='heading' />}
                                <Button type={'tertiary'} color={accentColor} href={githubLink}>
                                    {`${buttonText} &rarr;`}
                                </Button>
                            </>
                        )}
                    </Grid>
                </Grid>
            </Styled>
        </>
    );
};
